export const isCtrlKey = (e: { metaKey?: boolean; ctrlKey?: boolean }) => {
    return e.metaKey || e.ctrlKey;
};

export const isShiftKey = (e: { shiftKey?: boolean }) => {
    return e.shiftKey;
};
